<script setup lang="ts">
const props = defineProps<{
  title?: string
  description?: string
  closeButton?: () => void
}>()

const model = defineModel()
function closePopup() {
  model.value = false
  props.closeButton?.()
}
</script>

<template>
  <div
    class="page-center z-[51] flex h-fit max-h-[90%] w-[90%] flex-col overflow-hidden rounded-2xl bg-white p-spacing-lg shadow-md sm:max-h-[75%] md:max-w-[70%] 2xl:max-h-[80%] 2xl:max-w-[50%] 3xl:max-w-[40%]"
    :class="$attrs.class">
    <p
      class="secu-headline-bold mb-spacing-xs flex items-center justify-between gap-spacing-md">
      {{ title }}
      <button class="h-fit" :class="{ 'ml-auto': !title }" @click="closePopup">
        <SvgoCross class="relative size-6 fill-black" />
      </button>
    </p>
    <p v-if="description" class="secu-body mt-spacing-sm">
      {{ description }}
    </p>
    <slot />
  </div>
  <DimOverlay />
</template>
